import { IconBooks, IconNotes } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import useAuth from '@/hooks/useAuth';

import Fab from '@/components/Fab/Fab';
import FabPopupItem from '@/components/Fab/FabPopupItem';

interface CreatePlanFabProps {
  setShowAddPlanPopUp: (show: boolean) => void;
  setShowCustomPlan: (show: boolean) => void;
  setShowTemplateModal: (show: boolean) => void;
  showAddPlanPopUp: boolean;
}

const CreatePlanFab: React.FC<CreatePlanFabProps> = ({
  setShowAddPlanPopUp,
  setShowCustomPlan,
  setShowTemplateModal,
  showAddPlanPopUp,
}) => {
  const { t } = useTranslation();
  const { data: auth } = useAuth();
  const locationsWithAtLeastLeaderPermission =
    auth?.allLocationsWithAtLeastLeaderPermissions ?? [];
  const onShowCustomPlanPopup = () => {
    setShowCustomPlan(true);
    setShowAddPlanPopUp(false);
  };

  const onShowTemplateModal = () => {
    setShowTemplateModal(true);
    setShowAddPlanPopUp(false);
  };

  if (!locationsWithAtLeastLeaderPermission.length) {
    return null;
  }

  return (
    <Fab
      isOpen={showAddPlanPopUp}
      onClick={() => setShowAddPlanPopUp(!showAddPlanPopUp)}
      onClose={() => setShowAddPlanPopUp(false)}
      icon="plan-plus"
    >
      <FabPopupItem
        data-testid="CustomPlan"
        icon={<IconNotes />}
        onClick={onShowCustomPlanPopup}
        title={t('TrainingPlans.addPlanMenu.buildCustomPlan')}
      />
      <FabPopupItem
        data-testid="TemplateLibraryPlan"
        icon={<IconBooks />}
        onClick={onShowTemplateModal}
        title={t('TrainingPlans.addPlanMenu.choosePlanFromLibrary')}
      />
    </Fab>
  );
};

export default CreatePlanFab;
